"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
import { Calendar, Users, Sparkles } from "lucide-react";
export default function ShowDetails() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.3
  });
  return <section id="show-details" className="bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-3xl">
        {}
        <div ref={ref1} className={`flex flex-col items-center text-center hover-lift ${isVisible1 ? "animate-fade-in-up" : "opacity-0"}`}>
          <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 transition-transform duration-[var(--duration-medium)] hover:scale-110">
            <SafeHydrate><Calendar className="h-8 w-8 text-primary" /></SafeHydrate>
          </div>
          <h3 className="mb-2 font-display text-2xl font-semibold text-foreground">
            Limited Engagement
          </h3>
          <p className="text-muted-foreground max-w-md">
            Experience The Mass during its exclusive run at the Springfield Theater. Each performance is a unique journey through powerful storytelling and visual artistry.
          </p>
        </div>

        <Separator className="my-12 transition-opacity duration-[var(--duration-slow)]" />

        {}
        <div ref={ref2} className={`flex flex-col items-center text-center hover-lift ${isVisible2 ? "animate-fade-in-up-delay-100" : "opacity-0"}`}>
          <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-secondary/10 transition-transform duration-[var(--duration-medium)] hover:scale-110">
            <Users className="h-8 w-8 text-foreground" />
          </div>
          <h3 className="mb-2 font-display text-2xl font-semibold text-foreground">
            Audience Connection
          </h3>
          <p className="text-muted-foreground max-w-md">
            Join a community of theater enthusiasts and art lovers. The Mass invites you to engage deeply with themes of identity, community, and transformation through interactive elements.
          </p>
        </div>

        <Separator className="my-12 transition-opacity duration-[var(--duration-slow)]" />

        {}
        <div ref={ref3} className={`flex flex-col items-center text-center hover-lift ${isVisible3 ? "animate-fade-in-up-delay-200" : "opacity-0"}`}>
          <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-accent/10 transition-transform duration-[var(--duration-medium)] hover:scale-110">
            <Sparkles className="h-8 w-8 text-accent-dark" />
          </div>
          <h3 className="mb-2 font-display text-2xl font-semibold text-foreground">
            Original Artistry
          </h3>
          <p className="text-muted-foreground max-w-md">
            Created by Philip Gray, The Mass stands out as a bold theatrical event combining exceptional 
            acting, original music, and innovative stagecraft that redefines contemporary performance.
          </p>
        </div>
      </div>
    </section>;
}